import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const AddEditSlider = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [products, setProduct] = useState([]);
  const slider_image_detail = JSON.parse(localStorage.getItem("slider-list"));
  const storedSliderImageDetail = slider_image_detail;
  const BASE_IMAGE_URL = `${BASE_URL}/`;
  const [initialImagePath, setInitialImagePath] = useState(null);
  const isEditMode = storedSliderImageDetail?.id;
  const fetchProduct = async () => {
    try {
      const response = await api.post(`/slider/get`);
      if (response.data.success) {
        setProduct(response.data.product);
      } else {
        // setError("Product not found");
      }
    } catch (err) {
      //   setError("Error fetching product details");
    } finally {
      //   setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  useEffect(() => {
    if (storedSliderImageDetail && storedSliderImageDetail?.id) {
      setFormData((prev) => ({
        ...prev,
        id: storedSliderImageDetail.id || "",
        name: storedSliderImageDetail.name || "",
      }));

      if (storedSliderImageDetail.image) {
        const fullPath = storedSliderImageDetail.image.startsWith("http")
          ? storedSliderImageDetail.image
          : `${BASE_IMAGE_URL}${storedSliderImageDetail.image}`;

        setPreview(fullPath);
        setInitialImagePath(fullPath);
      }
    } else {
      setFormData([]);
    }
  }, [isEditMode]);

  const history = useHistory();
  const [formData, setFormData] = useState({
    name: "",
    image: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(e.target.files[0]);
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    if (image) {
      data.append("image", image);
    }
    try {
      let response;
      let url;
      let method;

      if (isEditMode) {
        url = `/slider/update/${isEditMode}`;
        method = api.post;
      } else {
        url = "/slider/create";
        method = api.post;
      }

      response = await method(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const successMessage = isEditMode
          ? "Slider updated successfully!"
          : "Slider added successfully!";

        toast.success(successMessage);
        history.push("/sliders");
      } else {
        toast.error(
          "Submission failed: " + (response.data.message || "Unknown error."),
        );
      }
    } catch (err) {
      const apiErrors = err.response?.data?.errors;
      if (apiErrors) {
        toast.error(
          "Validation failed: " + Object.values(apiErrors).flat().join(" | "),
        );
      } else {
        toast.error("Error submitting slider!");
      }
    }
  };
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>{isEditMode ? "Edit Slider" : "Add Slider"}</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Add Slider Image</div>
              </li>
            </ul>
          </div>
          {/* <!-- form-add-product --> */}
          <form
            className="tf-section-2 form-add-product"
            onSubmit={handleSubmit}
          >
            <div className="wg-box">
              <fieldset className="name">
                <div className="body-title mb-10">Name</div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter slider name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </fieldset>
              <fieldset className="mt-4">
                <div className="body-title mb-10">Upload Image</div>
                <input
                  type="file"
                  id="myFile"
                  name="image"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 p-2"
                />

                {preview && (
                  <div className="mt-4">
                    <img
                      src={preview}
                      alt="Preview"
                      className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                    />
                  </div>
                )}
              </fieldset>

              <div className="cols gap10 mt-4">
                <button className="tf-button style-1 w-full" type="submit">
                  Save Slider
                </button>
              </div>
            </div>
          </form>
          {/* <!-- /form-add-product --> */}
        </div>
        {/* <!-- /main-content-wrap --> */}
      </div>
    </>
  );
};
export default AddEditSlider;
